export const buildUploadMetadataPayload = (data = {}, countries = []) => {
  const countryCode = typeof data.country === "string"
    ? data.country.trim().toUpperCase()
    : "";
  const countryName = countries.find((country) => country.code === countryCode)?.name || "";

  return {
    ...data,
    countryCode,
    country: countryName,
  };
};

export default buildUploadMetadataPayload;
